module.exports = __webpack_public_path__ + "static/home-video-preview-c2c940f12451bbbbbe0060448c3899b4.mp4";